import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setLoadedTitle } from 'store/sessionSlice';
import Typer from 'components/Typer';
import MetaverseBackground from 'components/MetaverseBackground';
import { runCommand } from 'commands';

const TypeArea = ({ content }) => (
  <React.Fragment>
    <textarea
      style={{ ...styles.textArea, fontFamily: 'c64Mono', color: 'magenta' }}
      type="text"
      readOnly
      value={content}
    >
      {content}
    </textarea>
    <textarea
      style={{
        ...styles.textArea,
        fontFamily: 'c64Mono',
        color: 'black',
        transform: 'rotate(-.01deg) translateY(-40px)'
      }}
      type="text"
      readOnly
      value={content}
    >
      {content}
    </textarea>
  </React.Fragment>
);

const now = new Date();

const Page00 = ({ assetUrl, sitePage = null, story = null }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { username, scheme, overlay, loadedTitle } = useSelector(
    (s) => s.session
  );
  const { mixtape } = useSelector((s) => s.player);
  const [screenBuffer, setScreenBuffer] = useState([]);
  const [metaverse, setMetaverse] = useState(false);
  const [input, setInput] = useState('');

  const hiddenInputRef = useRef(null);
  const focusInput = () => hiddenInputRef.current?.focus();

  useEffect(() => {
    focusInput();
  }, []);

  const onKeyDown = (e) => {
    if (e.metaKey || e.ctrlKey || e.altKey) return;
    if (e.key === 'Enter') {
      runCommand(input, {
        dispatch,
        navigate,
        output: setScreenBuffer,
        showMetaverse: () => setMetaverse(true)
      });
      setInput('');
      e.preventDefault();
    }
  };

  useEffect(() => {
    if (story) {
      runCommand(`load ${story}`, {
        dispatch,
        navigate,
        output: setScreenBuffer,
        showMetaverse: () => setMetaverse(true)
      });
      return;
    }
    dispatch(setLoadedTitle(''));
    setScreenBuffer(
      `Welcome!<br> You are alone right now.<br> Type 'help' if you need it.<br>`
    );
  }, [username, navigate, story, dispatch]);

  const splash = !story;

  return (
    <React.Fragment>
      {splash &&
        ReactDOM.createPortal(
          <div className="title title-hero glitch" data-text="cyberdeck">
            cyberdeck
          </div>,
          document.body
        )}
      <div
        onClick={focusInput}
        className={splash ? 'term-body screen-blur' : 'term-body'}
        style={{
          ...styles.body,
          background: `radial-gradient(${scheme.bgInner}, ${scheme.bgOuter})`,
          color: scheme.text,
          '--main-color': scheme.text,
          '--link-color': scheme.link
        }}
      >
      <input
        ref={hiddenInputRef}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={onKeyDown}
        inputMode="text"
        autoCapitalize="off"
        autoCorrect="off"
        autoComplete="off"
        spellCheck={false}
        aria-hidden="true"
        style={{
          position: 'fixed',
          opacity: 0,
          pointerEvents: 'none',
          width: 1,
          height: 1,
          top: 0,
          left: 0,
          zIndex: -1
        }}
      />
      <div
        style={{
          position: 'fixed',
          inset: 0,
          background: '#000',
          opacity: overlay,
          pointerEvents: 'none',
          zIndex: -1
        }}
      />
      <Typer html={screenBuffer} />
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          background: 'white',
          width: '100vw',
          boxSizing: 'border-box',
          height: '3rem',
          display: 'flex',
          flexDirection: 'row',
          zIndex: 2,
          alignItems: 'center',
          padding: mixtape ? '0 1rem 0 6rem' : '0 1rem 0 3.2rem'
        }}
      >
        {loadedTitle ? (
          <span
            style={{
              position: 'relative',
              top: '.2rem',
              fontFamily: 'Foldit',
              fontSize: '2rem',
              transform: 'rotate(-1deg)',
              color: 'inherit',
              minWidth: 0,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            FOXRIOT: {loadedTitle}
          </span>
        ) : (
          <a
            href="https://foxriot.com"
            style={{
              position: 'relative',
              top: '.2rem',
              fontFamily: 'Foldit',
              fontSize: '2rem',
              transform: 'rotate(-1deg)',
              color: 'inherit',
              background: 'none',
              padding: 0,
              textDecoration: 'none',
              cursor: 'pointer'
            }}
          >
            FOXRIOT
          </a>
        )}
        <div style={{ flexGrow: 1 }} />
        <div
          className="cmd-entry"
          style={{
            flexShrink: 0,
            maxWidth: '25vw',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            fontFamily: 'c64',
            fontSize: '1.5rem',
            padding: '0.25rem 1rem',
            background: `color-mix(in srgb, ${scheme.bgOuter} 50%, white)`,
            color: scheme.text,
            borderRadius: '0.3rem',
            whiteSpace: 'pre'
          }}
        >
          <span>\></span>{input}
          <span className="type-cursor" style={{ color: scheme.text }} />
        </div>
      </div>
      </div>
    </React.Fragment>
  );
};
export default Page00;

const styles = {
  body: {
    height: '100vh',
    position: 'absolute',
    boxSizing: 'border-box',
    backgroundColor: 'white',
    background: 'radial-gradient(#444444, #000000)',
    width: '100vw',
    color: '#ff00ddc9',
    padding: '3rem',
    fontFamily: 'c64',
    paddingTop: '5rem',
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
    overflow: 'hidden',
    fontSize: '1.2rem',
    zIndex: -1
  }
};
